import moment from "moment";
import type { SignupType } from '../../types/signup';

import {
    CLEAR_SIGNUP_ERROR,
    CLEAR_SIGNUP_SUCCESS_MESSAGE,
    SIGNUP_ERROR,
    SIGNUP_PENDING,
    SIGNUP_PENDING_ERROR,
    SIGNUP_PENDING_SUCCESS,
    SIGNUP_SUCCESS,
} from '../constants/signup.constants' ;

const initialState : SignupType = {
    email: null,
    username: null,
    password: null,
    token: null,
    expires: null,
    errorMessage: null,
    isPending:false,
    successMessage:null,
}

export default (
    localState : SignupType = initialState,
    action: Action
) : SignupType => {
    switch(action.type){
        case SIGNUP_SUCCESS : {
            const { email, token, expires } = action.payload;
            return{
                ...localState,
                email,
                token,
                expires: moment().unix()+expires,
                errorMessage: null,
                isPending: false,
                successMessage: "A verification email has been sent. Please verify your email and log in."
            };
        }
        case SIGNUP_ERROR: {
            const { errorMessage } = action.payload;
            return {
                ...localState,
                errorMessage,
                isPending: false
            };
        }
        case SIGNUP_PENDING: {
            return{
                ...localState,
                isPending: true,
            };
        }
        case SIGNUP_PENDING_SUCCESS: {
            return{
                ...localState,
                isPending:false,
                signUpSuccessMessage: "A Verification link has been sent to your mail id. Please Activate your account using the link in your mail"
            }
        }
        case CLEAR_SIGNUP_SUCCESS_MESSAGE: {
            return{
                ...localState,
                isPending:false,
                signUpSuccessMessage: ""
            }
        }
        case SIGNUP_PENDING_ERROR: {
            return {
                ...localState,
                isPending: false,
            };
        }
        case CLEAR_SIGNUP_ERROR:{
            return{
                ...localState,
                errorMessage:null,
            };
        }
        default:{
            return localState;
        }
    }
}

